import { Component, OnInit, Inject, inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CommonDialogWrapperComponent } from '../../common-dialog-wrapper/common-dialog-wrapper.component';
import { MakersiteService } from '@services/makersite.service';
import { ToastrService } from '@services/toaster.service';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { ButtonComponent, InlineFormSchemaComponent, FormDataService } from '@mds/ui';
import { CommonCloseDialogType, CommonDialogButton } from '../../common-dialog-wrapper/common-dialog-wrapper.model';
import { RouterHelperService } from '@services/router-helper.service';

@Component({
  selector: 'app-edit-team-member',
  standalone: true,
  imports: [
    CommonDialogWrapperComponent,
    MatDialogModule,
    ButtonComponent,
    InlineFormSchemaComponent
],
  providers: [
    {
      provide: FormDataService,
      useFactory: (svc: MakersiteService) => new FormDataService(svc),
      deps: [MakersiteService]
    }
  ],
  templateUrl: './edit-team-member.component.html',
  styleUrls: ['./edit-team-member.component.scss']
})
export class EditTeamMemberComponent implements OnInit {
  schema: any;
  formData: any;
  lines: any;
  teamRid: string;

  submitButton: CommonDialogButton = {
    text: 'Submit',
    type: 'primary'
  };

  cancelButton: CommonDialogButton = {
    text: 'Cancel',
    type: 'secondary'
  };
  private routerHelperService = inject(RouterHelperService);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDailogRef: MatDialogRef<EditTeamMemberComponent>,
    private makersiteService: MakersiteService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.teamRid = this.data.teamRid;
    this.data.formSchema.forEach((el) => {
      if (el.formtype === 'autocomplete') {
        el.formtype = 'disabled';
      }
    });
    if (this.data.formSchema) {
      this.data.formSchema.forEach((schema) => {
        if (schema.formtype != 'checkbox') {
          schema.vertical = true;
        }
      });
    }
    this.schema = this.data;
    this.lines = this.data.lines;
  }

  formValueChanged(e) {
    this.formData = e;
  }

  openMenuItem(menuAction: any) {
    this.routerHelperService.openMenuItem(menuAction);
  }

  removeFromTeam() {
    let user_id = '';
    const team_id = this.teamRid;
    this.lines.forEach((el) => {
      if (el.key.endsWith('.in')) {
        user_id = el.rid;
      }
    });
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        header: 'Remove from team',
        text: 'Are you sure you want to remove user from team?',
        cancel_text: 'Cancel',
        delete_text: 'Remove'
      }
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.makersiteService.removeFromTeam(team_id, user_id).subscribe((res) => {
          this.toastrService.show('Removed user from team successfully!!', 1000);
          this.matDailogRef.close(true);
        });
      }
    });
  }

  submitData() {
    const key = this.schema.formSchema[0].key.split('.')[0];
    const values = this.formData.value.Inputs[key];
    const payload = {};
    payload[key] = {};

    this.lines.forEach((e) => {
      let line_key = e.key.split('.');
      line_key = line_key[line_key.length - 1];
      payload[key][line_key] = e.rid ? e.rid : e.value;
      if (!['in', 'rid'].includes(line_key)) {
        payload[key][line_key] = values[line_key];
      }
    });
    this.makersiteService.submitEditedMetadata(this.teamRid, payload).subscribe((res) => {
      this.toastrService.show('Updated Successfully', 1000);
      this.matDailogRef.close(true);
    });
  }

  onDialogClose(type: CommonCloseDialogType) {
    if (type === CommonCloseDialogType.CONFIRM) {
      this.submitData();
    } else {
      this.matDailogRef.close(true);
    }
  }
}
